<template lang="html">
    <div class="error-page" style="display:flex; height: 100vh; margin-top:0px;">
        <div style="margin:auto;">
            <div class="error-page__image">
                <img src="@/assets/images/logo.svg">
            </div>
            <div class="error-page__title">
                Plata a fost finalizată cu succes. Vă mulțumim!
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import  "@/scss/pages/_error-page.scss";
</style>
